import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Biography from "./pages/Biography";
import Horses, { HorseDetail } from "./pages/Horses";
import News, { NewsDetail } from "./pages/News";
import Blog, { BlogDetail } from "./pages/Blog";
import Photos from "./pages/Photos";
import Shop from "./pages/Shop";
import Sponsors from "./pages/Sponsors";
import Calendar from "./pages/Calendar";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/biography" element={<Biography />} />
            <Route path="/horses" element={<Horses />} />
            <Route path="/horses/:id" element={<HorseDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/calendar" element={<Calendar />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
